import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=1be4a791&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=1be4a791&prod&scoped=true&lang=css"
import style1 from "./Privacy.vue?vue&type=style&index=1&id=1be4a791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4a791",
  null
  
)

export default component.exports